import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, ShieldCheck, Zap, FileText } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-20 lg:pt-24 lg:pb-28 overflow-hidden bg-slate-50" data-id="element-49">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-50">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-teal-100/50 blur-3xl" data-id="element-51"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 rounded-full bg-blue-100/50 blur-3xl" data-id="element-52"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-53">
        <div className="flex flex-col items-center text-center" data-id="element-54">
          {/* Main Title */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-slate-900 leading-[1.1] tracking-tight mb-2" data-id="element-55">
            Sistema PRO:
          </h1>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-[#0D7377] leading-[1.1] tracking-tight mb-12" data-id="element-56">
            Podología
          </h1>

          {/* Product Image */}
          <div className="relative w-full max-w-2xl mx-auto mb-12" data-id="element-57">
            <a href="#comprar" className="block" data-id="element-58">
              <div className="relative" data-id="element-59">
                <img src="https://cdn.magicpatterns.com/uploads/7eXFjZSWCp5iiiqsm1ghDN/Mockup_podologia-Photoroom.png" alt="Sistema PRO Podología Mockup" className="w-full h-auto object-contain" data-id="element-60" />
              </div>
            </a>
            {/* Floating badge */}
            <div className="absolute -bottom-5 -right-4 bg-white p-3 rounded-xl shadow-xl border border-slate-100 hidden md:block" data-id="element-61">
              <div className="flex items-center gap-3" data-id="element-62">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-63">
                  <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-64" />
                </div>
                <div className="text-left" data-id="element-65">
                  <p className="text-sm font-bold text-slate-900" data-id="element-66">
                    Listo para usar
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-67">Imprimí y atendé</p>
                </div>
              </div>
            </div>
          </div>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl leading-relaxed" data-id="element-68">
            Para podólogos que quieren atender más y papelear menos. Un sistema
            completo de recursos clínicos listos para usar en tu consultorio
            desde el primer día.
          </p>

          {/* CTA Button */}
          <div className="mb-10" data-id="element-69">
            <Button href="#comprar" size="xl" variant="secondary" className="group" data-id="element-70">
              👉 Acceder al Sistema PRO ahora
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-slate-600" data-id="element-71">
            <div className="flex items-center gap-2" data-id="element-72">
              <ShieldCheck className="w-5 h-5 text-[#0D7377]" data-id="element-73" />
              <span data-id="element-74">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-75">
              <Zap className="w-5 h-5 text-[#0D7377]" data-id="element-76" />
              <span data-id="element-77">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-78">
              <FileText className="w-5 h-5 text-[#0D7377]" data-id="element-79" />
              <span data-id="element-80">PDF imprimible</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}